import {FILTERS_ARGS} from "../cm-const";

export default class CMFilterDTO {
  constructor(queries = {}) {
    this.search = queries[FILTERS_ARGS.SEARCH];
    this.examDateBefore = queries[FILTERS_ARGS.EXAM_DATE_BEFORE];
    this.examDateAfter = queries[FILTERS_ARGS.EXAM_DATE_AFTER];
    this.examLocation = queries[FILTERS_ARGS.EXAM_LOCATION];
  }

}
